<template>
  <div class="flex w-full px-2 sm:px-0 flex-col">
    <div class="flex justify-end mb-3 sm:mb-5">
      <button
              @click="back()"
              class=" flex bg-transparent bg-purple_dark sideBackground text-white font-semibold hover:text-white sm:py-2 py-4 px-4 rounded-full sm:rounded-lg">
        <ArrowLeftIcon class="sm:mr-2 self-center" size="1.1x"></ArrowLeftIcon>
        <span class="hidden sm:inline">
          Back
      </span>
      </button>
    </div>
    <div class="flex w-full justify-center">
      <div class="rounded shadow-2xl bg-white flex flex-col sm:p-5 p-3 w-full sm:w-full lg:w-1/2 xl:w-1/3">
        <div class="flex justify-between">
          <p class="text-2xl mb-5 font-semibold text-purple_dark self-center">
            Edit {{title}}
          </p>
          <!--        <span class=" self-start">-->
          <!--          <FolderPlusIcon class="text-blue-500" size="2x"></FolderPlusIcon>-->
          <!--        </span>-->
        </div>
        <div class="w-full">
          <ValidationObserver ref="observe" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)" class="">
              <div class="mb-3">
                <label class="block text-left text-md  mb-2">
                  Title
                </label>
                <ValidationProvider rules="required" v-slot="{errors}">
                  <input class="shadow w-full appearance-none rounded w-64 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                         placeholder="Title"
                         type="text" v-model="editObj.title">
                  <span class="text-red-dark">{{errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="mb-3">
                <label class="block text-left text-md  mb-2">
                  Author
                </label>
                <ValidationProvider rules="required" v-slot="{errors}">
                  <input class="shadow w-full appearance-none rounded w-64 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                         placeholder="Author"
                         type="text" v-model="editObj.author">
                  <span class="text-red-dark">{{errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="mb-3">
                <label class="block text-left text-md  mb-2">
                  Date
                </label>
                <ValidationProvider rules="required" v-slot="{errors}">
                  <input class="shadow w-full appearance-none rounded w-64 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                         placeholder="Date"
                         type="text" v-model="editObj.date">
                  <span class="text-red-dark">{{errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="mb-3">
                <label class="block text-left text-md  mb-2">
                  Description
                </label>
                <ValidationProvider rules="required" v-slot="{errors}">
                  <input class="shadow w-full appearance-none rounded w-64 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                         placeholder="Description"
                         type="text" v-model="editObj.description">
                  <span class="text-red-dark">{{errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="mb-3">
                <label class="block text-left text-md  mb-2">
                  Post Link
                </label>
                <ValidationProvider rules="required" v-slot="{errors}">
                  <input class="shadow w-full appearance-none rounded w-64 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                         placeholder="Link"
                         type="text" v-model="editObj.link">
                  <span class="text-red-dark">{{errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="mb-3">
                <label class="block text-left text-md  mb-2">
                  Image Link
                </label>
                <ValidationProvider rules="required" v-slot="{errors}">
                  <input class="shadow w-full appearance-none rounded w-64 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                         placeholder="Link"
                         type="text" v-model="editObj.post_image">
                  <span class="text-red-dark">{{errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="flex items-center justify-between mt-6">
                <button class="bg-purple w-full hover:bg-red-dark-700 text-white  py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="submit">
                  Publish Changes
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {ArrowLeftIcon} from "vue-feather-icons";
  import {db} from "../../db";
  import {eventBus} from "../../eventbus";

  export default {
    name: "BlogEdit",
    props: {
      editObj: {
        type: Object
      },
      blogKeys: {
        type: Array,
        required: true
      }
    },
    data: () => ({
      key: '',
      title: ''
    }),
    components: {
      // Edit3Icon,
      ArrowLeftIcon
    },
    methods: {
      onSubmit() {
        db.ref('blog_post/').child(this.key).update({
          author: this.editObj.author,
          date: this.editObj.date,
          description: this.editObj.description,
          link: this.editObj.link,
          post_image: this.editObj.post_image,
          title: this.editObj.title
          // eslint-disable-next-line no-unused-vars
        }).then(res => {
          this.$toast.open({
            message: 'Successful',
            type: 'success'
          });
          this.back()
        }).catch(
            // eslint-disable-next-line no-unused-vars
            err => {
              this.$toast.open({
                message: 'Something Went Wrong ' + err,
                type: 'error'
              });
            }
        )
      },
      findKey() {
        let state = this.blogKeys.find(item => item.title === this.editObj.title);
        this.key = state.key
        this.title = state.title

      },
      back() {
        eventBus.$emit('AllBlog')
      }
    },
    created() {
      this.findKey()
    }
  }
</script>

<style scoped>

</style>
